var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('CoreToolbar'),_c('CoreDrawer'),_c('CoreView'),_c('AdminFooter'),_c('AdminOpciones')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }